export const allValuesTruthy = (o: any) => !Object.values(o).some((x: string) => !x);
